import type { ComponentPropsWithRef } from 'react';
import { forwardRef } from 'react';

import clsx from 'clsx';

const radioSize = {
    sm: 'w-3 h-3 border-[1.5px] !bg-[length:9px_9px]',
    default: 'w-4 h-4 border-2 !bg-[length:12px_12px]'
} as const;

const radioStyle = {
    default: clsx(
        'border-icoGray-300 dark:border-icoDarkMode-beton',
        'disabled:border-icoGray-300 disabled:bg-icoGray-100 dark:disabled:border-icoDarkMode-beton dark:disabled:bg-icoDarkMode-anthracite',
        'disabled:hover:border-icoGray-300 disabled:hover:bg-icoGray-100 dark:disabled:hover:border-icoDarkMode-beton dark:disabled:hover:bg-icoDarkMode-anthracite'
    ),
    gray400: clsx(
        'border-icoGray-400 dark:border-icoDarkMode-beton',
        'disabled:disabled:border-icoGray-400 disabled:bg-icoGray-300 dark:disabled:border-icoDarkMode-wolf dark:disabled:bg-icoDarkMode-beton',
        'disabled:hover:border-icoGray-400 disabled:hover:bg-icoGray-300 dark:disabled:hover:border-icoDarkMode-wolf dark:disabled:hover:bg-icoDarkMode-beton'
    )
};

export type RadioProps = Omit<ComponentPropsWithRef<'input'>, 'size'> & {
    className?: string;
    disabled?: boolean;
    size?: keyof typeof radioSize;
    boxStyle?: keyof typeof radioStyle;
};

const Radio = forwardRef<HTMLInputElement, RadioProps>(
    (
        { className, disabled = false, size = 'default', boxStyle = 'default', ...restProps },
        ref
    ) => {
        return (
            <input
                ref={ref}
                className={clsx(
                    className,
                    radioSize[size],
                    radioStyle[boxStyle],
                    'cursor-pointer disabled:cursor-not-allowed',
                    'text-icoBlue',
                    'focus:ring-icoBlue-200 focus:ring-offset-0',
                    'hover:border-icoBlue focus:border-icoBlue'
                )}
                type="radio"
                disabled={disabled}
                {...restProps}
            />
        );
    }
);

Radio.displayName = 'Radio';

export default Radio;
